import React from "react";
import { HotelData } from "../../context/searchProvider";
import { cn, formatCurrency } from "@/lib/utils";

type Props = {
  hotel: HotelData;
  isDimmed?: boolean;
  isSelected?: boolean;
};

const CuratedHotelMarker: React.FC<Props> = ({
  hotel,
  isDimmed,
  isSelected,
}) => {
  const price = formatCurrency(hotel.nightlyRate!, hotel.lowestRateCurrency, 0);

  return (
    <div
      className={cn(
        "marker-shadow flex gap-1 rounded-full border border-pure-black/5 bg-pure-white px-4 py-2 text-pure-black",
        isDimmed && "opacity-50",
        isSelected && "bg-brand-gold text-brand-gold-foreground"
      )}
    >
      {price}
    </div>
  );
};

export default CuratedHotelMarker;
